import React, { useState } from "react";
import "../../styles/Listing.css";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import ResidentialListing from "../../components/Checklists/Saskatchewan/ResidentialListing.js";
import LeaseListing from "../../components/Checklists/Saskatchewan/LeaseListing.js";
import AssignmentListing from "../../components/Checklists/Saskatchewan/AssignmentListing.js";

export default function Listing() {
  const [ListingType, setListingType] = useState("");

  let listingTemplate = "";
  if (ListingType === "Residential") {
    listingTemplate = <ResidentialListing />;
  } else if (ListingType === "Lease") {
    listingTemplate = <LeaseListing />;
  } else if (ListingType === "Assignment") {
    listingTemplate = <AssignmentListing />;
  } else {
    listingTemplate = "";
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const setTemplate = (e) => {
    setListingType(e.target.value);
  };

  return (
    <div className="checklists flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-4">
          <div>Residential Listing Type:</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
              >
                <FormControlLabel
                  value="Residential"
                  control={<Radio size="small" onClick={setTemplate} />}
                  label="For Sale"
                />
                <FormControlLabel
                  value="Lease"
                  control={<Radio size="small" onClick={setTemplate} />}
                  label="For Lease"
                />
                <FormControlLabel
                  value="Assignment"
                  control={<Radio size="small" onClick={setTemplate} />}
                  label="Assignment"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
      </div>
      {listingTemplate}
    </div>
  );
}
